module.exports = __webpack_public_path__ + "6dd7058e33ac5f720fe53de09709e25b.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/header_1_new.jpg
// module id = 302
// module chunks = 0